import { Lock } from "lucide-react";
export const EncryptedStatus = ({
    isEncrypted,
}: {
    isEncrypted: boolean;
}) => {
    return (
        <div
            data-testid="chat.encrypted-status"
            className={`inline-block px-2 py-1 text-xs font-medium rounded-full ${
                isEncrypted
                    ? 'text-emerald-700'
                    : ''
            }`}
        >
            {isEncrypted ? <div className={"flex items-center gap-2 text-emerald-700 text-xxs font-medium"}>
                <Lock size={11} className={' text-emerald-700'} /> This chat is end-to-end encrypted
            </div> : ''}
        </div>
    );
}